<template>
  <header>
    <div id="banner">
      <div class="img">
        <div class="mobile">
          <img
            src="../../../images/views/client/home/header-phone-pc.png"
            alt="Banner for Mobile"
          />
        </div>
        <div class="desktop">
          <img
            src="../../../images/views/client/home/header-phone-pc.png"
            alt="Banner for Desktop"
          />
        </div>
      </div>
      <div class="caption-box">
        <ul class="caption">
          <li class="logo">
            <img
              src="../../../images/logo-wh.png"
              alt="Reeracoen Freelance Recruiting Service"
            />
          </li>
          <li class="heading">
            <h1>
              The best digital platform to hire <span>Tech Talents</span> in
              Thailand!
            </h1>
          </li>
          <li class="tagline">
            <h2>
              Connecting with
              <span>50+ professional tech recruiters</span> networks with us!
            </h2>
          </li>
          <li class="cta-button">
            <a href="/" class="btn btn-blue">Send Job Request!</a>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: "BannerClient",
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
header {
  #banner {
    align-items: stretch;
    background: #001ee2;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: auto;
    width: 100%;
  }
  .img {
    padding-top: 50px;
    padding-left: 90px;
    width: 30%;

    img {
      height: 100%;
      object-fit: cover;
      transform: translate3d(0, 0, 0);
      width: 100%;
    }

    .mobile {
      display: none;
    }

    .desktop {
      display: block;
    }
  }

  .caption-box {
    align-self: center;
    width: 70%;

    .caption {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      padding: 5rem 4rem;

      & > * {
        margin-bottom: 1.25rem;
      }

      .logo {
        img {
          opacity: 0.8;
          width: 350px;
        }
      }

      .heading {
        h1 {
          color: $white;
          font-weight: 500;
          font-size: 2em;
          span {
            color: #f6c7dc;
            font-size: larger;
          }
        }
      }

      .tagline {
        h2 {
          color: $white;
          font-size: 1.5em;
          font-weight: 400;
          letter-spacing: 1px;
          line-height: 2.5rem;
          span {
            font-weight: 600 !important;
            font-size: larger;
          }
        }
      }

      .cta-button {
        .btn {
          background: #f6c7dc;
          color: $black;
          font-size: 1.35em;
          padding: 1.5rem 3rem;
        }
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  header {
    #banner {
      display: flex;
      flex-direction: column;
      width: 100%;

      .caption-box {
        width: 100%;
        padding: 2rem 2rem;
        padding-bottom: 0;

        .caption {
          align-items: center;
          justify-content: center;
          padding: 1.5rem 0;
          text-align: center;

          & > * {
            margin-bottom: 1.25rem;
          }

          .logo {
            img {
              width: 250px;
            }
          }

          .heading {
            h1 {
              font-size: 1.75em;
              line-height: 1.5em;
            }
          }

          .tagline {
            h2 {
              font-size: 1.2em;
              line-height: 2rem;
            }
          }

          .cta-button {
            width: 100%;

            .btn {
              display: block;
              font-size: 1em;
              padding: 1rem 1.5rem;
              width: 100%;
            }
          }
        }
      }
      .img {
        padding-top: 0;
        padding-left: 0;
        order: 2;
        width: 100%;

        img {
          float: unset;
          height: 100%;
          width: 250px;
          margin: 0 auto;
        }

        .mobile {
          display: block;
        }

        .desktop {
          display: none;
        }
      }
    }
  }
}
</style>
